<template>
  <b-card no-body class="card-profile">
    <b-row class="justify-content-center">
      <b-col lg="3" class="order-lg-2">
        <div class="card-profile-image">
          <b-img :src="user.image !== null ? user.image.absoluteUri : '/img/DefaultUser.gif'" rounded="circle" />
        </div>
      </b-col>
    </b-row>

    <b-card-body class="pt-5 mt-5">
      <div class="text-center">
        <h5 class="h3">
          {{ user.userName }}
        </h5>
        <div class="h5 font-weight-300">
          {{ user.email }}
        </div>
         <div class="mt-4">
          <i class="ni education_hat mr-2"></i>{{ company }}
        </div>
        <div class="h5">
          <i class="ni business_briefcase-24 mr-2"></i>{{ user.title }}
        </div>
       
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  props: {
    user: Object,
    company: String
  }
};
</script>
<style></style>
